import Link from "../../utils/Link";
import * as React from "react";
import useTranslations from "../../../hooks/useTranslations";
import UserAvatar from "../../utils/avatars/UserAvatar";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import { ActivityFragment, CompanyMinimalFragment, UserMinimalFragment } from '../../../graphql/generated/definitions';

type UserUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: UserMinimalFragment;
};

interface UserUpdatedActivityProps {
  activity: UserUpdatedActivity;
}

export function isUserUpdatedActivity(
  q: ActivityFragment
): q is UserUpdatedActivity {
  return q.key === "user.updated";
}

export const UserUpdatedActivity: React.FC<UserUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();
  const { trackable } = activity;

  return (
    <Activity
      activity={activity}
      id="userUpdatedActivity"
      visual={
        <UserAvatar
          src={trackable.avatar}
          alt={`${trackable.name} avatar`}
          size={10}
        />
      }
    >
      <Text fontSize="sm">
        {t("activity.labels.userUpdated", {
          user: (
            <Link to={`/users/${activity.trackable.slug}`}>
              {activity.trackable.name}
            </Link>
          ),
        })}
      </Text>
    </Activity>
  );
};
